import React from 'react';
import CloseSvg from '@atlas-design-system/core/dist/svg/close.svg';

import IconBase from './IconBase';

const CloseIcon = React.forwardRef((props, ref) => (
  <IconBase {...props} ref={ref} Icon={CloseSvg} />
));

CloseIcon.displayName = 'CloseIcon';

export default CloseIcon;
